import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { useServerData } from '../../state/serverDataContext';

const TermsConditionsLoadable = loadable(
  () => import(/* webpackChunkName: 'TermsConditions' */ './locales/TermsConditions'),
  {
    fallback: <></>,
  }
);

export const TermsConditionsPropTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  linkName: PropTypes.string,
  linkUrl: PropTypes.string,
};

const TermsConditions = () => {
  const { name, description, linkName, linkUrl, locale } = useServerData(data => ({
    name: data.pageData?.termsConditions?.name,
    description: data.pageData?.termsConditions?.description,
    linkName: data.pageData?.termsConditions?.linkName,
    linkUrl: data.pageData?.termsConditions?.linkUrl,
    locale: data.locale,
  }));

  if (!name || !description) {
    return null;
  }

  return (
    <TermsConditionsLoadable
      data-testid="terms-conditions"
      locale={locale}
      name={name}
      description={description}
      linkName={linkName}
      linkUrl={linkUrl}
    />
  );
};

export default TermsConditions;
